import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import React, { lazy } from 'react';
import { ConfigurationReference, getConf, readConfObject } from '@jbrowse/core/configuration';
import { getEnv, getSession, getContainingView, isSelectionContainer } from '@jbrowse/core/util';
import { BaseLinearDisplay } from '@jbrowse/plugin-linear-genome-view';
import { when } from 'mobx';
import { isAlive, types } from 'mobx-state-tree';
import { axisPropsFromTickScale } from 'react-d3-axis-mod';
import { getNiceDomain, getScale, getStats, statsAutorun, YSCALEBAR_LABEL_OFFSET } from '../../util';
import Tooltip from '../components/Tooltip';
import YScaleBar from '../../shared/YScaleBar';
var SetMinMaxDlg = lazy(function () {
  return import('../../shared/SetMinMaxDialog');
});
var SetColorDlg = lazy(function () {
  return import('../components/SetColorDialog');
});
// using a map because it preserves order
var rendererTypes = new Map([['xyplot', 'XYPlotRenderer'], ['density', 'DensityRenderer'], ['line', 'LinePlotRenderer']]);
/**
 * #stateModel LinearWiggleDisplay
 * Extends `BaseLinearDisplay`
 */
function stateModelFactory(pluginManager, configSchema) {
  return types.compose('LinearWiggleDisplay', BaseLinearDisplay, types.model({
    /**
     * #property
     */
    type: types.literal('LinearWiggleDisplay'),
    /**
     * #property
     */
    configuration: ConfigurationReference(configSchema),
    /**
     * #property
     */
    selectedRendering: types.optional(types.string, ''),
    /**
     * #property
     */
    resolution: types.optional(types.number, 1),
    /**
     * #property
     */
    fill: types.maybe(types.boolean),
    /**
     * #property
     */
    minSize: types.maybe(types.number),
    /**
     * #property
     */
    color: types.maybe(types.string),
    /**
     * #property
     */
    posColor: types.maybe(types.string),
    /**
     * #property
     */
    negColor: types.maybe(types.string),
    /**
     * #property
     */
    summaryScoreMode: types.maybe(types.string),
    /**
     * #property
     */
    rendererTypeNameState: types.maybe(types.string),
    /**
     * #property
     */
    scale: types.maybe(types.string),
    /**
     * #property
     */
    autoscale: types.maybe(types.string),
    /**
     * #property
     */
    displayCrossHatches: types.maybe(types.boolean),
    /**
     * #property
     */
    constraints: types.optional(types.model({
      max: types.maybe(types.number),
      min: types.maybe(types.number)
    }), {})
  })).volatile(function () {
    return {
      message: undefined,
      stats: undefined,
      statsFetchInProgress: undefined
    };
  }).actions(function (self) {
    return {
      /**
       * #action
       */
      updateStats: function updateStats(stats) {
        var scoreMin = stats.scoreMin,
          scoreMax = stats.scoreMax;
        var EPSILON = 0.000001;
        if (!self.stats) {
          self.stats = {
            scoreMin: scoreMin,
            scoreMax: scoreMax
          };
        } else if (Math.abs(self.stats.scoreMax - scoreMax) > EPSILON || Math.abs(self.stats.scoreMin - scoreMin) > EPSILON) {
          self.stats = {
            scoreMin: scoreMin,
            scoreMax: scoreMax
          };
        }
      },
      /**
       * #action
       */
      setColor: function setColor(color) {
        self.color = color;
      },
      /**
       * #action
       */
      setPosColor: function setPosColor(color) {
        self.posColor = color;
      },
      /**
       * #action
       */
      setNegColor: function setNegColor(color) {
        self.negColor = color;
      },
      /**
       * #action
       */
      setLoading: function setLoading(aborter) {
        var statsFetch = self.statsFetchInProgress;
        if (statsFetch !== undefined && !statsFetch.signal.aborted) {
          statsFetch.abort();
        }
        self.statsFetchInProgress = aborter;
      },
      /**
       * #action
       * this overrides the BaseLinearDisplayModel to avoid popping up a
       * feature detail display, but still sets the feature selection on the
       * model so listeners can detect a click
       */
      selectFeature: function selectFeature(feature) {
        var session = getSession(self);
        if (isSelectionContainer(session)) {
          session.setSelection(feature);
        }
      },
      /**
       * #action
       */
      setResolution: function setResolution(res) {
        self.resolution = res;
      },
      /**
       * #action
       */
      setFill: function setFill(fill) {
        if (fill === 0) {
          self.fill = true;
          self.minSize = 0;
        } else if (fill === 1) {
          self.fill = false;
          self.minSize = 1;
        } else if (fill === 2) {
          self.fill = false;
          self.minSize = 2;
        }
      },
      /**
       * #action
       */
      toggleLogScale: function toggleLogScale() {
        if (self.scale !== 'log') {
          self.scale = 'log';
        } else {
          self.scale = 'linear';
        }
      },
      /**
       * #action
       */
      setScaleType: function setScaleType(scale) {
        self.scale = scale;
      },
      /**
       * #action
       */
      setSummaryScoreMode: function setSummaryScoreMode(val) {
        self.summaryScoreMode = val;
      },
      /**
       * #action
       */
      setAutoscale: function setAutoscale(val) {
        self.autoscale = val;
      },
      /**
       * #action
       */
      setMaxScore: function setMaxScore(val) {
        self.constraints.max = val;
      },
      /**
       * #action
       */
      setRendererType: function setRendererType(val) {
        self.rendererTypeNameState = val;
      },
      /**
       * #action
       */
      setMinScore: function setMinScore(val) {
        self.constraints.min = val;
      },
      /**
       * #action
       */
      toggleCrossHatches: function toggleCrossHatches() {
        self.displayCrossHatches = !self.displayCrossHatches;
      },
      /**
       * #action
       */
      setCrossHatches: function setCrossHatches(cross) {
        self.displayCrossHatches = cross;
      }
    };
  }).views(function (self) {
    return {
      /**
       * #getter
       */
      get TooltipComponent() {
        return Tooltip;
      },
      /**
       * #getter
       */
      get adapterTypeName() {
        return self.adapterConfig.type;
      },
      /**
       * #getter
       */
      get rendererTypeNameSimple() {
        return self.rendererTypeNameState || getConf(self, 'defaultRendering');
      },
      /**
       * #getter
       */
      get rendererTypeName() {
        var name = this.rendererTypeNameSimple;
        var rendererType = rendererTypes.get(name);
        if (!rendererType) {
          throw new Error("unknown renderer ".concat(name));
        }
        return rendererType;
      },
      /**
       * #getter
       * subclasses can define these, as snpcoverage track does
       */
      get filters() {
        return undefined;
      },
      /**
       * #getter
       */
      get scaleType() {
        return self.scale || getConf(self, 'scaleType');
      },
      /**
       * #getter
       */
      get maxScore() {
        var _a;
        return (_a = self.constraints.max) !== null && _a !== void 0 ? _a : getConf(self, 'maxScore');
      },
      /**
       * #getter
       */
      get minScore() {
        var _a;
        return (_a = self.constraints.min) !== null && _a !== void 0 ? _a : getConf(self, 'minScore');
      }
    };
  }).views(function (self) {
    return {
      /**
       * #getter
       */
      get rendererConfig() {
        var configBlob = getConf(self, ['renderers', self.rendererTypeName]) || {};
        var color = self.color,
          displayCrossHatches = self.displayCrossHatches,
          fill = self.fill,
          minSize = self.minSize,
          negColor = self.negColor,
          posColor = self.posColor,
          summaryScoreMode = self.summaryScoreMode,
          scaleType = self.scaleType;
        return self.rendererType.configSchema.create(_objectSpread({}, configBlob, scaleType ? {
          scaleType: scaleType
        } : {}, fill !== undefined ? {
          filled: fill
        } : {}, displayCrossHatches !== undefined ? {
          displayCrossHatches: displayCrossHatches
        } : {}, summaryScoreMode !== undefined ? {
          summaryScoreMode: summaryScoreMode
        } : {}, color !== undefined ? {
          color: color
        } : {}, negColor !== undefined ? {
          negColor: negColor
        } : {}, posColor !== undefined ? {
          posColor: posColor
        } : {}, minSize !== undefined ? {
          minSize: minSize
        } : {}), getEnv(self));
      }
    };
  }).views(function (self) {
    var oldDomain = [0, 0];
    return {
      /**
       * #getter
       */
      get filled() {
        var fill = self.fill,
          conf = self.rendererConfig;
        return fill !== null && fill !== void 0 ? fill : readConfObject(conf, 'filled');
      },
      /**
       * #getter
       */
      get summaryScoreModeSetting() {
        var summaryScoreMode = self.summaryScoreMode,
          conf = self.rendererConfig;
        return summaryScoreMode !== null && summaryScoreMode !== void 0 ? summaryScoreMode : readConfObject(conf, 'summaryScoreMode');
      },
      /**
       * #getter
       */
      get domain() {
        var stats = self.stats,
          scaleType = self.scaleType,
          minScore = self.minScore,
          maxScore = self.maxScore;
        if (!stats) {
          return undefined;
        }
        var ret = getNiceDomain({
          domain: [stats.scoreMin, stats.scoreMax],
          bounds: [minScore, maxScore],
          scaleType: scaleType
        });
        // avoid weird scalebar if log value and empty region displayed
        if (scaleType === 'log' && ret[1] === Number.MIN_VALUE) {
          return [0, Number.MIN_VALUE];
        }
        // avoid returning a new object if it matches the old value
        if (JSON.stringify(oldDomain) !== JSON.stringify(ret)) {
          oldDomain = ret;
        }
        return oldDomain;
      },
      /**
       * #getter
       */
      get needsScalebar() {
        return self.rendererTypeName === 'XYPlotRenderer' || self.rendererTypeName === 'LinePlotRenderer';
      },
      /**
       * #getter
       */
      get scaleOpts() {
        return {
          domain: this.domain,
          stats: self.stats,
          autoscaleType: this.autoscaleType,
          scaleType: self.scaleType,
          inverted: getConf(self, 'inverted')
        };
      },
      /**
       * #getter
       */
      get canHaveFill() {
        return self.rendererTypeName === 'XYPlotRenderer';
      },
      /**
       * #getter
       */
      get autoscaleType() {
        var _a;
        return (_a = self.autoscale) !== null && _a !== void 0 ? _a : getConf(self, 'autoscale');
      },
      /**
       * #getter
       */
      get displayCrossHatchesSetting() {
        var hatches = self.displayCrossHatches,
          conf = self.rendererConfig;
        return hatches !== null && hatches !== void 0 ? hatches : readConfObject(conf, 'displayCrossHatches');
      }
    };
  }).views(function (self) {
    return {
      /**
       * #getter
       */
      get ticks() {
        var scaleType = self.scaleType,
          domain = self.domain,
          height = self.height;
        var minimalTicks = getConf(self, 'minimalTicks');
        var inverted = getConf(self, 'inverted');
        var range = [height - YSCALEBAR_LABEL_OFFSET, YSCALEBAR_LABEL_OFFSET];
        if (!domain) {
          return undefined;
        }
        var scale = getScale({
          scaleType: scaleType,
          domain: domain,
          range: range,
          inverted: inverted
        });
        var ticks = axisPropsFromTickScale(scale, 4);
        return height < 100 || minimalTicks ? _objectSpread({}, ticks, {
          values: domain
        }) : ticks;
      },
      /**
       * #getter
       */
      get adapterCapabilities() {
        var type = self.adapterTypeName;
        return pluginManager.getAdapterType(type).adapterCapabilities;
      }
    };
  }).views(function (self) {
    var superRenderProps = self.renderProps;
    return {
      /**
       * #method
       */
      renderProps: function renderProps() {
        var superProps = superRenderProps();
        var filters = self.filters,
          ticks = self.ticks,
          height = self.height,
          resolution = self.resolution,
          scaleOpts = self.scaleOpts;
        return _objectSpread({}, superProps, {
          notReady: superProps.notReady || !self.stats,
          rpcDriverName: self.rpcDriverName,
          displayModel: self,
          config: self.rendererConfig,
          displayCrossHatches: self.displayCrossHatchesSetting,
          scaleOpts: scaleOpts,
          resolution: resolution,
          height: height,
          ticks: ticks,
          filters: filters
        });
      },
      /**
       * #getter
       */
      get hasResolution() {
        return self.adapterCapabilities.includes('hasResolution');
      },
      /**
       * #getter
       */
      get hasGlobalStats() {
        return self.adapterCapabilities.includes('hasGlobalStats');
      },
      /**
       * #getter
       */
      get fillSetting() {
        if (self.filled) {
          return 0;
        } else if (!self.filled && self.minSize === 1) {
          return 1;
        } else {
          return 2;
        }
      }
    };
  }).views(function (self) {
    var superTrackMenuItems = self.trackMenuItems;
    var hasRenderings = getConf(self, 'defaultRendering');
    return {
      /**
       * #method
       */
      trackMenuItems: function trackMenuItems() {
        return [].concat(_toConsumableArray(superTrackMenuItems()), _toConsumableArray(self.hasResolution ? [{
          label: 'Resolution',
          subMenu: [{
            label: 'Finer resolution',
            onClick: function onClick() {
              return self.setResolution(self.resolution * 5);
            }
          }, {
            label: 'Coarser resolution',
            onClick: function onClick() {
              return self.setResolution(self.resolution / 5);
            }
          }]
        }, {
          label: 'Summary score mode',
          subMenu: ['min', 'max', 'avg', 'whiskers'].map(function (elt) {
            return {
              label: elt,
              type: 'radio',
              checked: self.summaryScoreModeSetting === elt,
              onClick: function onClick() {
                return self.setSummaryScoreMode(elt);
              }
            };
          })
        }] : []), _toConsumableArray(self.canHaveFill ? [{
          label: 'Fill mode',
          subMenu: ['filled', 'no fill', 'no fill w/ emphasis'].map(function (elt, idx) {
            return {
              label: elt,
              type: 'radio',
              checked: self.fillSetting === idx,
              onClick: function onClick() {
                return self.setFill(idx);
              }
            };
          })
        }] : []), [{
          label: self.scaleType === 'log' ? 'Set linear scale' : 'Set log scale',
          onClick: function onClick() {
            return self.toggleLogScale();
          }
        }], _toConsumableArray(self.needsScalebar ? [{
          type: 'checkbox',
          label: 'Draw cross hatches',
          checked: self.displayCrossHatchesSetting,
          onClick: function onClick() {
            return self.toggleCrossHatches();
          }
        }] : []), _toConsumableArray(hasRenderings ? [{
          label: 'Renderer type',
          subMenu: ['xyplot', 'density', 'line'].map(function (key) {
            return {
              label: key,
              type: 'radio',
              checked: self.rendererTypeNameSimple === key,
              onClick: function onClick() {
                return self.setRendererType(key);
              }
            };
          })
        }] : []), [{
          label: 'Autoscale type',
          subMenu: [['local', 'Local']].concat(_toConsumableArray(self.hasGlobalStats ? [['global', 'Global'], ['globalsd', 'Global ± 3σ']] : []), [['localsd', 'Local ± 3σ']]).map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
              val = _ref2[0],
              label = _ref2[1];
            return {
              label: label,
              type: 'radio',
              checked: self.autoscaleType === val,
              onClick: function onClick() {
                return self.setAutoscale(val);
              }
            };
          })
        }, {
          label: 'Set min/max score',
          onClick: function onClick() {
            getSession(self).queueDialog(function (handleClose) {
              return [SetMinMaxDlg, {
                model: self,
                handleClose: handleClose
              }];
            });
          }
        }, {
          label: 'Set color',
          onClick: function onClick() {
            getSession(self).queueDialog(function (handleClose) {
              return [SetColorDlg, {
                model: self,
                handleClose: handleClose
              }];
            });
          }
        }]);
      }
    };
  }).actions(function (self) {
    var superReload = self.reload,
      superRenderSvg = self.renderSvg;
    return {
      /**
       * #action
       * re-runs stats and refresh whole display on reload
       */
      reload: function () {
        var _reload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var aborter, stats;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                self.setError();
                aborter = new AbortController();
                self.setLoading(aborter);
                _context.prev = 3;
                _context.next = 6;
                return getStats(self, _objectSpread({
                  signal: aborter.signal
                }, self.renderProps()));
              case 6:
                stats = _context.sent;
                if (isAlive(self)) {
                  self.updateStats(stats);
                  superReload();
                }
                _context.next = 13;
                break;
              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);
                self.setError(_context.t0);
              case 13:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[3, 10]]);
        }));
        function reload() {
          return _reload.apply(this, arguments);
        }
        return reload;
      }(),
      afterAttach: function afterAttach() {
        statsAutorun(self);
      },
      /**
       * #action
       */
      renderSvg: function () {
        var _renderSvg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(opts) {
          var needsScalebar, stats, _getContainingView, offsetPx;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return when(function () {
                  return !!self.stats && !!self.regionCannotBeRenderedText;
                });
              case 2:
                needsScalebar = self.needsScalebar, stats = self.stats;
                _getContainingView = getContainingView(self), offsetPx = _getContainingView.offsetPx;
                _context2.t0 = React;
                _context2.t1 = React.Fragment;
                _context2.t2 = React;
                _context2.t3 = {
                  id: "snpcov"
                };
                _context2.next = 10;
                return superRenderSvg(opts);
              case 10:
                _context2.t4 = _context2.sent;
                _context2.t5 = _context2.t2.createElement.call(_context2.t2, "g", _context2.t3, _context2.t4);
                _context2.t6 = needsScalebar && stats ? React.createElement("g", {
                  transform: "translate(".concat(Math.max(-offsetPx, 0), ")")
                }, React.createElement(YScaleBar, {
                  model: self,
                  orientation: "left"
                })) : null;
                return _context2.abrupt("return", _context2.t0.createElement.call(_context2.t0, _context2.t1, null, _context2.t5, _context2.t6));
              case 14:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function renderSvg(_x) {
          return _renderSvg.apply(this, arguments);
        }
        return renderSvg;
      }()
    };
  });
}
export default stateModelFactory;